import { useMutation } from '@tanstack/react-query'
import {
  sendJahisMaster,
  JahisMasterSendRequest,
} from '../../../../apis/jahisMaster'

/**
 * 用法マスタ送信 Mutation hook
 */
export const useSendJahisMasterMutation = () => {
  return useMutation({
    mutationFn: (params: JahisMasterSendRequest) => sendJahisMaster(params),
  })
}
